import { useEffect, useState, useContext, useRef } from "react";
import { useLocation, useHistory, Link } from 'react-router-dom';

import { LayoutContext } from "../layout";
import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function Home(props) {
    const { mobile, setPageTitle } = useContext(LayoutContext);

    const location = useLocation();
    const history = useHistory();

    const [data, setData] = useState({ slides: [], categories: [] });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const slickRef = useRef(null);

    useEffect(() => {
        if (sessionStorage.getItem('orderSuccess')) {
            setShowSuccessModal(true);
            sessionStorage.removeItem('orderSuccess');
        }
    }, []);

    useEffect(() => {
        setPageTitle('تامین 360');

        const controller = new AbortController();
        const { signal } = controller;

        const fetchData = async () => {
            try {
                setLoading(true);

                // run in parallel
                const [imagesliderRes, categoryRes] = await Promise.all([
                    fetch(getEndpoint("/api/android/imageslider/getall"), { signal }),
                    fetch(getEndpoint("/api/android/category/getrootitems"), { signal }),
                ]);

                if (!imagesliderRes.ok || !categoryRes.ok) throw new Error("Network error");

                const [slides, categories] = await Promise.all([
                    imagesliderRes.json(),
                    categoryRes.json(),
                ]);

                setData({ slides, categories });

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    useEffect(() => {
        if (!data || !data.slides || !data.slides.data) return;        

        $(slickRef.current).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: data.slides.data.length > 1,
            fade: false,
            rtl: true,
            infinite: false
        });
    }, [data]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <div className="home-slider p-r" dir='rtl'>
                <div className="js__slider slider d-f ac-fs o-h p-r us-n w-100" ref={slickRef}>
                    {data.slides.data.map(x => (
                        <img key={x.id} className="js__slider-img" src={getEndpoint(`/uploads/shop/slider/${x.picture}`)} />
                    ))}
                </div>
            </div>
            <div className="home-categories d-f fw-w p-4" style={{ fontSize: '90%' }}>
                {data.categories.data.map(x => (
                    <Link
                        key={x.id}
                        className="d-f ai-c jc-c p-2 br-6 c-w mb-4 ws-nw"
                        to={(x.childCount == 0 ? `/products/${x.id}` : `/category/${x.id}`)}
                        style={{ backgroundColor: '#2b6bb4' }}
                        children={x.title} />
                ))}
            </div>

            {showSuccessModal && (
                <div className='p-f l-0 t-0 w-100vw h-100vh d-f ai-c' style={{ zIndex: 200 }}>
                    <div className='p-f l-0 t-0 w-100vw h-100vh zi-80' style={{ backgroundColor: 'rgba(0,0,0, .5)' }} onClick={e => setShowSuccessModal(false)} />
                    <div className='p-r bc-w mx-4 zi-90 p-4 fs-3 bsh-2 br-2 w-100 fw-600 ta-c'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 32 32" className='mx-a'>
                            <path fill='#4caf50' d="M16 25.156q4.375 0 7.531-3.156t3.156-7.531-3.156-7.531-7.531-3.156-7.531 3.156-3.156 7.531 3.156 7.531 7.531 3.156zM16 1.156q5.5 0 9.406 3.906t3.906 9.406-3.906 9.406-9.406 3.906-9.406-3.906-3.906-9.406 3.906-9.406 9.406-3.906zM22.125 8.594l1.875 1.875-10.688 10.688-6.625-6.688 1.875-1.875 4.75 4.75z"></path>
                        </svg>

                        <div className='mt-5'>سفارش شما با موفقیت ثبت شد</div>
                        <div className='mt-2' style={{ color: '#777777', fontSize: '.75em' }}>
                            می توانید از طریق بخش سفارش ها آخرین وضعیت سفارش خود را دنبال کنید.
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}